export const COLOR_WHITE = "#FFFFFF";
export const COLOR_BLACK = "#060605";
export const COLOR_GRAY = "#8D8D8D";
export const COLOR_YELLOW = "#E6B812";
export const COLOR_RED = "#F97878";
